import React from "react";
import { renderLayout } from "schema/ThemeSet.react";
import InputField from "slides/components/InputField.react";

export default class Anagram extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shuffled_word: this.jumbledWords(this.props.data.answer),
        };
    }
    handleClick = (answer) => {
        this.props.trackInteraction(answer);
    };

    jumbledWords = (answer) => {
        return answer
            .toUpperCase()
            .split("")
            .sort(function () {
                return 0.5 - Math.random();
            })
            .join("");
    };

    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let LayoutRender = renderLayout(isPortrait, this.props.layout);
        let answer = this.props.data.answer
            .toString()
            .trim()
            .replace(/[a-z0-9&_]/gi, "*");

        return (
            <div className="full-height">
                <LayoutRender
                    {...this.props}
                    title={"Let us know:"}
                    mainContent={
                        <div>
                            <h1>{this.state.shuffled_word}</h1>
                            <br />
                            <InputField
                                {...this.props}
                                placeholder={answer}
                                handleClick={this.handleClick}
                                smallField={true}
                            />
                        </div>
                    }
                />
            </div>
        );
    }
}
